export default "__VITE_ASSET__Fhvso1PU__"